import React from "react";
import { Sparkles } from "lucide-react";

const EXTERIOR =
  "https://customer-assets.emergentagent.com/job_rmaart-store/artifacts/dkkxw3bl_WhatsApp%20Image%202026-04-27%20at%2022.48.01.jpeg";
const STATIONARY =
  "https://customer-assets.emergentagent.com/job_rmaart-store/artifacts/z4hzahox_WhatsApp%20Image%202026-04-27%20at%2022.47.38%20%282%29.jpeg";
const UTENSILS =
  "https://customer-assets.emergentagent.com/job_rmaart-store/artifacts/8eghe3b0_WhatsApp%20Image%202026-04-27%20at%2022.47.38%20%281%29.jpeg";
const JOCKEY =
  "https://customer-assets.emergentagent.com/job_rmaart-store/artifacts/k5hap9i3_WhatsApp%20Image%202026-04-27%20at%2022.47.37%20%282%29.jpeg";
const CLOTHES_MEN =
  "https://customer-assets.emergentagent.com/job_rmaart-store/artifacts/xf8eclyr_WhatsApp%20Image%202026-04-27%20at%2022.47.37.jpeg";

const photos = [
  {
    src: EXTERIOR,
    label: "Our Storefront",
    caption: "R Maart, Watur Road, Partur — lit up every evening.",
    span: "md:col-span-8 md:row-span-2",
    aspect: "aspect-[16/10] md:aspect-auto md:h-full",
    testid: "gallery-exterior",
  },
  {
    src: STATIONARY,
    label: "Stationary & Gifts",
    caption: "Notebooks, colour boxes, soft toys, diaries and bags.",
    span: "md:col-span-4",
    aspect: "aspect-[4/3]",
    testid: "gallery-stationary",
  },
  {
    src: UTENSILS,
    label: "Utensils & Kitchen",
    caption: "Steel plates, pressure cookers, containers, tiffins & more.",
    span: "md:col-span-4",
    aspect: "aspect-[4/3]",
    testid: "gallery-utensils",
  },
  {
    src: JOCKEY,
    label: "Jockey & Innerwear",
    caption: "Premium brands for women and men.",
    span: "md:col-span-6",
    aspect: "aspect-[4/3]",
    testid: "gallery-jockey",
  },
  {
    src: CLOTHES_MEN,
    label: "Men's Apparel",
    caption: "T-shirts, polos, jeans and casual essentials.",
    span: "md:col-span-6",
    aspect: "aspect-[4/3]",
    testid: "gallery-clothes-men",
  },
];

export default function StoreGallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-20 sm:py-28 bg-white relative overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute -top-24 left-1/3 w-[420px] h-[420px] rounded-full bg-[#F5EFE0] blur-3xl opacity-60"
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="font-latin text-xs uppercase tracking-[0.3em] text-[#9B8B3E] mb-3">
              Our Store
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#1A1813] leading-tight">
              Step inside <span className="text-[#9B8B3E] italic">R Maart</span>
            </h2>
            <p className="mt-4 text-[#5C5646] text-base sm:text-lg font-latin">
              A modern shopping experience in the heart of Partur — bright aisles,
              curated displays, and everything your family needs.
            </p>
          </div>
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#F5EFE0] border border-[#9B8B3E]/20 w-fit">
            <Sparkles className="w-3.5 h-3.5 text-[#9B8B3E]" />
            <span className="font-latin text-[12px] tracking-[0.15em] uppercase text-[#857635] font-medium">
              Real Photos from Partur
            </span>
          </div>
        </div>

        <div className="grid md:grid-cols-12 gap-4 md:gap-5 md:auto-rows-[260px]">
          {photos.map((p) => (
            <PhotoTile key={p.testid} {...p} />
          ))}
        </div>
      </div>
    </section>
  );
}

function PhotoTile({ src, label, caption, span, aspect, testid }) {
  return (
    <figure
      data-testid={testid}
      className={`relative overflow-hidden rounded-3xl border border-[#E5E1D5] bg-[#FBF9F6] group ${span} ${aspect}`}
    >
      <img
        src={src}
        alt={label}
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.06]"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/10 to-transparent opacity-90" />
      <figcaption className="absolute inset-x-0 bottom-0 p-5 sm:p-6">
        <div className="font-latin text-[10px] tracking-[0.25em] uppercase text-white/80 font-medium mb-1.5">
          {label}
        </div>
        <div className="font-display text-white text-lg sm:text-xl leading-snug font-medium max-w-sm">
          {caption}
        </div>
      </figcaption>
    </figure>
  );
}
